export const determineWorkplace = (
  countryCode: string,
  currentWorkplace: string | undefined
) => {
  if (['VN'].includes(countryCode)) return currentWorkplace || '';
  return undefined;
};
